import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cnpjCpfFormat'
})
export class CnpjCpfFormatPipe implements PipeTransform {

  transform(valor?: string): string {

    if (!valor) {
      return '';
    }

    const valorLimpo = valor.replace(/\D/g, '');

    if (valorLimpo.length === 11) {
      return valorLimpo.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
        '$1.$2.$3-$4'
      );
    } else if (valorLimpo.length === 14) {
      
      return valorLimpo.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5'
      );
    }

    return '';

  }

}
